import { useEffect } from 'react';
import type { CombiCharacteristic } from '../../schema';
import { useEvaluated } from '../../eval/EvalContext';
import { useTranslation } from '../../i18n';
import { formatCalculatedValue } from './formatCalculatedValue';

/**
 * Read-only display of the combi result. Field list + operator land in
 * `console.debug` only — never on screen.
 */
export function CombiView({ characteristic }: { characteristic: CombiCharacteristic }) {
    const { locale } = useTranslation();
    const result = useEvaluated(characteristic.id);

    useEffect(() => {
        console.debug(
            '[configento] combi result',
            characteristic.altTitle || characteristic.id,
            {
                operator: characteristic.operatorValue ?? '+',
                fields: characteristic.combiFields,
                result,
            },
        );
    }, [
        characteristic.id,
        characteristic.altTitle,
        characteristic.operatorValue,
        characteristic.combiFields,
        result,
    ]);

    return (
        <span className="cfg-calc-value" data-configento-eval-result>
            {formatCalculatedValue(result, characteristic.decimalPlace, locale)}
        </span>
    );
}
